import React from 'react'
import styled, { css } from 'styled-components'

const width = '24'
const height = '24'
const viewBox = '0 0 24 24'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      key="key-0"
      d="M23.66 11.61c-.83-.97-2.91-3.57-3.4-5.56a.97.97 0 00-.94-.77h-3.96v4.8h4.32c.27 0 .48.21.48.48s-.21.48-.48.48H0v4.32c0 .8.64 1.44 1.44 1.44h1.49a2.398 2.398 0 004.7 0h7.78a2.398 2.398 0 004.7 0h2.45c.8 0 1.44-.64 1.44-1.44v-2.82c0-.34-.12-.67-.34-.93zM5.28 17.76c-.8 0-1.44-.64-1.44-1.44s.64-1.44 1.44-1.44c.8 0 1.44.64 1.44 1.44 0 .79-.65 1.44-1.44 1.44zm7.68-3.84h-2.88c-.27 0-.48-.21-.48-.48s.21-.48.48-.48h2.88c.27 0 .48.21.48.48s-.21.48-.48.48zm4.8 3.84c-.8 0-1.44-.64-1.44-1.44s.64-1.44 1.44-1.44 1.44.64 1.44 1.44c0 .79-.65 1.44-1.44 1.44z"
    />,
    <path
      key="key-1"
      d="M10.56 5.28h3.84v4.8h-3.84zm-4.8 0H9.6v4.8H5.76zm-.96 0H1.44C.64 5.28 0 5.92 0 6.72v3.36h4.8v-4.8z"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconVan'
})
